__turbopack_context__.v({
  "root": "Code-module__8FihoW__root",
});
